<template>
  <div class="content-wrapper remove_table_shadow">
    <!-- <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('packages')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
     -->
    <!-- <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("create_package") }}
          </button>
        </div> -->
    <!-- </div> -->
    <!-- </div> -->

    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    />

    <div
      class="card card-with-search border-0 card-with-shadow d-none"
      v-for="(item, index) in packages"
      :key="index"
    >
      <div
        class="
          card-header
          d-flex
          justify-content-between
          align-items-center
          p-primary
          bg-transparent
        "
      >
        <h5 class="card-title d-inline-block mb-0">{{ item.title }}</h5>
      </div>
      <div class="card-body">
        <div class="text-justify" v-for="inc in item.include" :key="inc">
          {{ inc }}
        </div>
      </div>

      <app-button
        :label="$t('purchase_now')"
        class-name="btn-success mr-2"
        :is-disabled="false"
        @submit="btnSubmit(item.id)"
      />
    </div>

    <packages-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <certificate-view
      v-if="isCertificateViewModalActive"
      :certificate_id="certificateId"
      :company_id="companyId"
      @close-modal="closeCertificateViewModal"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import * as actions from "../../../Config/ApiUrl";
import { TableHelpers } from "../Demo/Tables/mixins/TableHelpers";
// import AppFunction from "../core/helpers/app/AppFunction";
import AppFunction from "../../../../core/helpers/app/AppFunction";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper.js";
import { Input } from "element-ui";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      isCertificateViewModalActive: false,
      certificateId: 0,
      companyId: 0,
      packages: {},
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      input: {},
      options: {
        name: "AdvanceTable",
        url: actions.PUBLIC_DOCUMENTS,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("type"),
            type: "custom-html",
            key: "title",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("document_name"),
            type: "custom-html",
            key: "description",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("issue_date"),
            type: "custom-html",
            key: "pivot",
            modifier: (value) => {
              return `<span>${value.issue_date}</span>`;
            },
          },
          // {
          //   title: this.$t("expiry_status"),
          //   type: "custom-html",
          //   key: "expiry_date",
          //   modifier: (value) => {
          //     const date1 = new Date(value);
          //     const date2 = new Date();
          //     // One day in milliseconds
          //     const oneDay = 1000 * 60 * 60 * 24;
          //     // Calculating the time difference between two dates
          //     const diffInTime = date1.getTime() - date2.getTime();
          //     // Calculating the no. of days between two dates
          //     const diffInDays = Math.round(diffInTime / oneDay);
          //     
          //     if (diffInDays <= 20 && diffInDays >= 11) {
          //       return `<span class="badge badge-sm badge-pill badge-warning">${this.$t(
          //       diffInDays+' Days left'
          //     )}</span>`;
                
          //     }
          //     else if(diffInDays <= 10) {
          //       if (diffInDays < 1) {
          //         return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
          //           'Document Expired'
          //         )}</span>`;
          //       }
          //       else {
          //         return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
          //           diffInDays+' Days left'
          //         )}</span>`;
          //       }
                
          //     }
          //     else {
          //       return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
          //       diffInDays+' Days left'
          //     )}</span>`;
          //     }
              
          //   },
          // },
        ],
        actions: [
          // {
          //   title: this.$t("edit"),
          //   icon: "edit",
          //   type: "none",
          //   component: "app-add-modal",
          //   modalId: "demo-add-edit-Modal",
          // },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "demo-delete",
          // },
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  mounted() {
    // this.getPackages();
    var company_id = this.$store.state.userCompanyProfile.dataProfile.company_id;
    if (company_id != null) {
      this.options.url = actions.COMPANY_CERTIFICATE_LIST+'/'+company_id;
    }
    setTimeout(() => {
      $( ".remove_table_shadow .h-100 .datatable .table-responsive " ).removeClass("shadow");
    }, 1000);
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("view")) {
        // window.location = '/admin/certificate/view/'+rowData.id;
        this.view(rowData.id);
      }
    },
    view(id) {
      this.certificateId = id;
      this.companyId = this.$store.state.userCompanyProfile.dataProfile.company_id;

      this.isCertificateViewModalActive = true;
    },
    closeCertificateViewModal() {
      this.certificateId = 0;
      $("#certificate-view-Modal").modal("hide");
      this.isCertificateViewModalActive = false;
    },

    buyerCertificate(id) {
      this.input.id = id;
      axiosPost(actions.BUYER_CERTIFICATE_STORE, this.input)
        .then((res) => {
          this.$toastr.s(res.data);
          location.reload();
        })
        .catch((error) => {
          this.$toastr.s(error);
        });
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    // getPackages() {
    //   axiosGet(actions.ADMIN_CERTIFICATE)
    //     .then((res) => {
    //       this.packages = res.data.data;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    btnSubmit(id) {
      location.replace("/admin/stripePay/" + id);
    },
  },
};
</script>
<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
